<div class="sticky-banner" (window:resize)="detectScreenSize()">
    <div class="left-side">
        <div class="count-text">{{filterService.compareFundCount}} fund(s) selected</div>
        <div class="seperater" *ngIf="innerwidth>576"></div>
        <div class="other-text">Compare up to five funds</div>
    </div>
    <div class="right-side">
        <div class="clear-container">
            <a (click)="clearSelected()" role="button" href="javascript:void(0)" class="clear-filter">Clear selected</a>
        </div>
        <div class="compare-button">
            <c11n-button [buttonType]="'button'" [size]="'medium'" [variant]="'primary'" [href]="finalURL" [labelText]="'Compare'"
                [colorMode]="'on-dark'" class="button-width" (clickEvent)="compareFunds($event)"></c11n-button>
        </div>
    </div>
</div>
